import { Group, Stack, Divider, Flex, Center, Alert } from "@mantine/core"

interface Props {
  leftPanelContent?: React.ReactNode
  rightPanelContent?: React.ReactNode
}

export function PageLayoutGroup33_66({
  leftPanelContent,
  rightPanelContent,
}: Props) {
  return (
    <Group maw="100%" wrap="nowrap" gap="xs" h="100%" w="100%">
      <Stack flex="0 0 32%" h="100%" gap="xs">
        {leftPanelContent ?? (
          <Center w="100%" h="100%">
            <Alert title="No content" color="red" />
          </Center>
        )}
      </Stack>
      <Divider orientation="vertical" />
      <Flex flex="0 0 67%" w="0" h="100%">
        {rightPanelContent}
      </Flex>
    </Group>
  )
}
